import { render, staticRenderFns } from "./IconCloseCircle.vue?vue&type=template&id=cca24edc"
import script from "./IconCloseCircle.vue?vue&type=script&lang=js"
export * from "./IconCloseCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports